module.exports = __webpack_public_path__ + "img/Exploring_Well_Known_CSS_Layouts.070a3456.jpeg";